import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {AcademyMedia} from '../../models/academy-media.model';
import {TranslationService} from '../../services/translation.service';
import {environment} from '../../../environments/environment';
import {MediaService} from '../../services/media.service';
import {User} from '../../models/user.model';
import {Router} from '@angular/router';
import {LocaleService} from '../../services/locale.service';
import {DateMomentService} from '../../services/date-moment.service';
import _ from "lodash";


@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-lecture',
    templateUrl: './lecture.component.html',
    styleUrls: ['./lecture.component.scss'],
    providers: [MediaService]
})
export class LectureComponent implements OnInit {
    @Input() lecture: AcademyMedia;
    environment: any = environment;
    @Input() user: User;
    @Input() card: boolean;
    @Input() thumbFormat: string;
    @Input() favoriteElement: boolean = true;
    @Input() isForReport: boolean = false;
    locale: string;
    languagesToDisplay: Array<any> =[];
    remainingLang: number = 0;

    constructor(public translationService: TranslationService,
                private mediaService: MediaService,
                public dateMomentService: DateMomentService,
                private router: Router,
                private localeService: LocaleService) {
    }

    ngOnInit() {
        this.locale = this.localeService.currentLocale();
        if(this.lecture.getMedia().languages.length > 0 ) {
          if(this.lecture.getMedia().languages.length > 2) {
            const test = _.cloneDeep(this.lecture.getMedia().languages);
            this.languagesToDisplay = test.splice(0,1);
            this.remainingLang = this.lecture.getMedia().languages.length - 1;
          } else {
            this.languagesToDisplay = this.lecture.getMedia().languages;
          }
        }
    }

    goToUserProfile(url) {
        this.router.navigateByUrl(url);
    }

    goToVideo(type?: string) {
      if (type && type === 'link') {
        this.router.navigateByUrl('/show/' + this.lecture.getId() + '/' + this.lecture.getSlug());
      } else {
        this.mediaService.goToVideo(this.lecture);
      }
    }

    addMediaToFavorite() {
        this.mediaService.addMediaToFavorite(this.lecture.getId()).subscribe(
            () => {
                const favorite = this.lecture.getFavorite(this.user);
                if (favorite === true) {
                    this.lecture.getMedia().favorite = false;
                    this.user.removeFavoriteAcademyMedia(this.lecture.getId());
                } else {
                    this.lecture.getMedia().favorite = true;
                    if (typeof this.user.addFavoriteAcademyMedia === 'function') {
                        this.user.addFavoriteAcademyMedia(this.lecture.getId());
                    }
                }
            },
            err => {}
        );
    }
}
